module.exports = require("@bechtel/client-assets/dist/images/route-not-found.svg");